import { Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useAppDispatch } from '@/hooks/redux'
import { getProfileApi } from '@/utils/appApi'

const StripeWaiting: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))

  const getResponsiveValue = (
    mobile: string,
    tablet: string,
    desktop: string,
  ) => {
    if (isMobile) return mobile
    if (isTablet) return tablet
    return desktop
  }

  const gapValue = getResponsiveValue('20px', '25px', '30px')
  const widthValue = getResponsiveValue('300px', '400px', '500px')

  const fetchProfile = () => {
    getProfileApi()
      .then((res) => {
        if (!res?.subscriptions?.length) {
          toast.error(
            'No active subscription found. Please select a plan to continue.',
          )
          navigate('/plans')
          return
        }

        toast.success('Subscription activated successfully!')
        navigate('/')
      })
      .catch(() => {
        toast.error('Failed to update profile. Redirecting...')
        navigate('/plans')
      })
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchProfile()
    }, 5000)

    return () => clearTimeout(timer)
  }, [navigate, dispatch])

  const gradientBg =
    'linear-gradient(133.84deg, #4e4e4e -16.04%, #333333 9.33%, #1a1a1a 32.02%, #1a1a1a 62.06%, #262626 87.42%, #4e4e4e 112.12%)'
  return (
    <div
      style={{
        minHeight: '100vh',
        background: gradientBg,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontFamily: 'MyriadPro, sans-serif',
        padding: '20px',
        gap: gapValue,
      }}
    >
      {' '}
      {/* Main heading */}
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: '20px', sm: '26px', md: '32px' },
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        Processing Subscription...
      </Typography>
      {/* Description */}
      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: '14px', sm: '16px', md: '18px' },
          textAlign: 'center',
          color: '#ffffff',
          opacity: 0.9,
          lineHeight: 1.6,
          px: { xs: 1, sm: 2 },
        }}
      >
        Thank you for subscribing! We're setting up your account and activating
        your subscription.
      </Typography>
      {/* Additional info */}
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: '12px', sm: '14px', md: '16px' },
          textAlign: 'center',
          color: '#ffffff',
          opacity: 0.7,
          px: { xs: 1, sm: 2 },
        }}
      >
        You will be redirected to your dashboard shortly.
      </Typography>
      {/* Progress indicator */}
      <div
        style={{
          width: widthValue,
          height: isMobile ? '3px' : '4px',
          background: 'rgba(255, 255, 255, 0.1)',
          borderRadius: '2px',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            background: 'linear-gradient(90deg, #44dec5 0%, #4ebcfa 100%)',
            animation: 'progress 5s ease-in-out',
          }}
        />
      </div>
      <style>
        {`
          @keyframes progress {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(0%); }
          }
        `}
      </style>
    </div>
  )
}

export default StripeWaiting
